import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { STORE_PRICE_TIER } from '../../action'
import { Redux } from '../..'

interface GetPriceTierListResponse {
  data: string[]
}

type PriceTierListStateType = {
  priceTierList: string[]
  pending: boolean
  errors: any
}

const initialState: PriceTierListStateType = {
  priceTierList: [],
  pending: false,
  errors: {}
}

// ** Fetch Price Tier
export const getPriceTierList = createAsyncThunk<GetPriceTierListResponse, void, Redux>(
  STORE_PRICE_TIER,
  async (_, { extra }) => {
    const response = await extra.httpClient(`restaurants/price-tiers`)

    return response.data
  }
)

export const priceTierList = createSlice({
  name: STORE_PRICE_TIER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // get price Tier
      .addCase(getPriceTierList.pending, state => {
        state.pending = true
      })
      .addCase(getPriceTierList.fulfilled, (state, action) => {
        state.priceTierList = action.payload.data
        state.pending = false
      })
      .addCase(getPriceTierList.rejected, state => {
        state.pending = false
      })
  }
})

export default priceTierList.reducer
